import * as React from 'react'
import { CellContext } from '@tanstack/react-table'
import { Team } from 'store/modules/teams'
import { formatDistanceToNowStrict } from 'date-fns'

export const LastEditCell = (data: CellContext<Team, unknown>) => {
  const lastEdit = data.cell.row.original?.updatedAt

  return (
    <div className="flex flex-row justify-start items-center text-gray-600">
      {formatDistanceToNowStrict(new Date(lastEdit), {
        unit: 'day',
        roundingMethod: 'ceil',
      })}{' '}
      ago
    </div>
  )
}
